export default __webpack_public_path__ + "static/media/elle7.1c5438d3.webp";